import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import { VendedorFilters as VendedorFiltersType } from '@/types/vendedores';

interface VendedorFiltersProps {
  filters: VendedorFiltersType;
  onFiltersChange: (filters: VendedorFiltersType) => void;
}

export function VendedorFilters({ filters, onFiltersChange }: VendedorFiltersProps) {
  const handleLimparFiltros = () => {
    onFiltersChange({
      periodo: '30_dias',
      status: 'todos',
      ordenacao: 'valor_contratos'
    });
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <Label htmlFor="periodo">Período</Label>
            <Select
              value={filters.periodo}
              onValueChange={(value: any) => onFiltersChange({ ...filters, periodo: value })}
            >
              <SelectTrigger id="periodo">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="7_dias">Últimos 7 dias</SelectItem>
                <SelectItem value="30_dias">Últimos 30 dias</SelectItem>
                <SelectItem value="90_dias">Últimos 90 dias</SelectItem>
                <SelectItem value="12_meses">Últimos 12 meses</SelectItem>
                <SelectItem value="todos">Todo o período</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="status">Status</Label>
            <Select
              value={filters.status}
              onValueChange={(value: any) => onFiltersChange({ ...filters, status: value })}
            >
              <SelectTrigger id="status">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="todos">Todos</SelectItem>
                <SelectItem value="ativo">Apenas ativos</SelectItem>
                <SelectItem value="inativo">Apenas inativos</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="ordenacao">Ordenar por</Label>
            <Select
              value={filters.ordenacao}
              onValueChange={(value: any) => onFiltersChange({ ...filters, ordenacao: value })}
            >
              <SelectTrigger id="ordenacao">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="nome">Nome</SelectItem>
                <SelectItem value="data_inicio">Data de início</SelectItem>
                <SelectItem value="total_parceiros">Total de parceiros</SelectItem>
                <SelectItem value="total_leads">Total de leads</SelectItem>
                <SelectItem value="valor_contratos">Valor de contratos</SelectItem>
                <SelectItem value="taxa_conversao">Taxa de conversão</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-end">
            <Button 
              variant="outline" 
              onClick={handleLimparFiltros}
              className="w-full"
            >
              <X className="h-4 w-4 mr-2" />
              Limpar Filtros
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

